export default __webpack_public_path__ + "static/Mobile-673f5d2232a393892b32c0a5a5d5b469.svg";